"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRaydiumPools = exports.getMndePrice = exports.getLarixPrice = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const fetch = require('node-fetch');
function getLarixPrice() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch("https://api.coingecko.com/api/v3/simple/price?ids=larix&vs_currencies=usd");
        const result = (yield response.json());
        return new bignumber_js_1.default(result.larix.usd);
    });
}
exports.getLarixPrice = getLarixPrice;
function getMndePrice() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch("https://api.coingecko.com/api/v3/simple/price?ids=marinade&vs_currencies=usd");
        const result = yield response.json();
        return new bignumber_js_1.default(result.marinade.usd);
    });
}
exports.getMndePrice = getMndePrice;
function getRaydiumPools() {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch("https://api.raydium.io/pairs");
        const result = (yield response.json());
        return result;
    });
}
exports.getRaydiumPools = getRaydiumPools;
